import { render, staticRenderFns } from "./CustomMarkdownEditor.vue?vue&type=template&id=3d55a260&scoped=true&"
import script from "./CustomMarkdownEditor.vue?vue&type=script&lang=js&"
export * from "./CustomMarkdownEditor.vue?vue&type=script&lang=js&"
import style0 from "./CustomMarkdownEditor.vue?vue&type=style&index=0&id=3d55a260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d55a260",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VRow,VTextarea})
